import { render, staticRenderFns } from "./SelectedGroups.vue?vue&type=template&id=fad30e70&"
import script from "./SelectedGroups.vue?vue&type=script&lang=js&"
export * from "./SelectedGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports